import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { TenantTypeView } from "./TenantTypeView";
import { TenantTypeViewStore } from "../../store/TenantTypeViewStore";
import { useStore } from "../../../../hooks";

export const TenantTypeViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/tenantType/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new TenantTypeViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <TenantTypeView tenantTypeViewStore={store} />
      </PageLayout>
    </div>
  );
});
